<template>
  <div>
    <h2>Game Lobby</h2>
    <v-row>
      <v-col>
        <team
          :player="player"
          team-name="A"
          :team-player="teamA"
          v-on:joinTeam="joinTeam"
        ></team>
      </v-col>
      <v-col align-self="center">
        <v-btn
          block
          @click="$emit('beCodemaster')"
          v-if="beCodeMasterButtonVisible"
          :class="{ 'mb-3': isHost }"
        >
          Be codemaster
        </v-btn>
        <v-btn color="primary" @click="$emit('start')" block v-if="isHost">
          Begin
        </v-btn>
      </v-col>
      <v-col>
        <team
          :player="player"
          team-name="B"
          :team-player="teamB"
          v-on:joinTeam="joinTeam"
        ></team>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Team from './Team';

export default {
  name: 'Lobby',
  components: { Team },
  props: {
    isHost: {
      type: Boolean,
      required: true,
    },
    player: {
      type: Object,
      required: true,
    },
    teamA: {
      type: Array,
      required: true,
    },
    teamB: {
      type: Array,
      required: true,
    },
  },
  computed: {
    teamAHasCodeMaster() {
      return this.teamA.filter((player) => player.isCodeMaster).length > 0;
    },
    teamBHasCodeMaster() {
      return this.teamB.filter((player) => player.isCodeMaster).length > 0;
    },
    beCodeMasterButtonVisible() {
      if (this.player.team === null) {
        return false;
      }

      return !this.player.isCodeMaster;
    },
  },
  methods: {
    joinTeam(team) {
      this.$emit('joinTeam', team);
    },
  },
};
</script>

<style scoped></style>
